<template lang="pug">
div
  v-form(ref="form")
    v-card.rounded-lg.content-box(outlined)
      div.pa-6
        v-row
          v-col(cols="7")
            div.text-md.font-semibold.neutral700--text Offers email
            div.text-sm.neutral700--text Configure your offers email

            div.text-md.font-semibold.neutral700--text.mt-5 Email subject line
            v-text-field.text-sm.mt-2.round-xl(v-model="blast.subject" placeholder="Enter email subject line here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
            div.text-xs.neutral500--text.ml-3.mt-2 The email subject line is only used when sending email
            
            div.text-md.font-semibold.neutral700--text.mt-5 Email preview text
            v-text-field.text-sm.mt-2.round-xl(v-model="blast.preview_text" placeholder="Enter email notification preview line" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
            div.text-xs.neutral500--text.ml-3.mt-2 This text will appear in the inbox after the subject line
          
          v-divider.neutral300.my-n3(vertical)
          v-col.py-0(cols="5")
            email-preview(:subject-line="blast.subject" :notification-preview-line="blast.preview_text")
      
      v-divider.neutral300
      div.pa-6
        div.text-md.font-semibold.neutral700--text Offers email content
        page-editor.mt-3.mx-(v-if="showFroala" :parentForm.sync="blast.content")
        div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
        div.d-flex.align-center.mt-1
          v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('offer_name')")
            span.neutral700--text Offer details
          v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('recipient_name')")
            span.neutral700--text Customer name
          v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('company_name')")
            span.neutral700--text Clinic’s name
          v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('company_phone')")
            span.neutral700--text Phone number
          template(v-if="offer.redeem_method != 'show_message'")
            v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('offer_code')")
              span.neutral700--text Promo code

    v-card.rounded-lg.content-box.pa-6.mt-6(outlined)
      v-row
        v-col(cols="7")
          div.text-md.font-semibold.neutral700--text Message blast frequency
          div.text-md.font-medium.neutral700--text.mt-5 Send this offer:
          v-card.round-xl.mt-2.pa-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            v-radio-group.mt-0(v-model="blast.send_cue")
              v-radio.mt-3(value="offer_activated" color="neutral700")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Immediately after this offer is created
              v-radio.mt-3(value="scheduled" color="neutral700" style="align-items: unset;")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Later on:
              template(v-if="blast.send_cue && blast.send_cue === 'scheduled'")
                div.ml-8.mt-4
                  v-row(dense)
                    v-col.grow
                      div.text-sm.font-semibold.neutral500--text Date
                    v-col.grow
                      div.text-sm.font-semibold.neutral500--text Time
                    v-col.shrink
                      div.pl-7
                  template(v-for="(schedule, index) in schedules")
                    v-row(dense :key="`sch-${index}`")
                      v-col.grow
                        date-picker-field(v-model="schedule.date" required :min="getTodayDate()" :disabled="schedules.length && schedules.length !== (index + 1)")
                      v-col.grow
                        v-text-field.text-sm.round-xl(v-model="schedule.time" outlined dense height="48" :rules="rules.not_empty" type="time" :background-color="schedules.length && schedules.length !== (index + 1) ? '' : 'neutral100'" :disabled="schedules.length && schedules.length !== (index + 1)" hide-details="auto")
                      v-col.shrink
                        v-btn.mt-2(v-if="index && schedules.length === (index + 1)" icon small @click="deleteSchedule()")
                          v-icon $yzi-trash-03
                        div.pl-7(v-else)
                  y-button.mt-3(label="Add more" prepend-icon="$yzi-plus" size="sm" @click="schedules.push({ time: '00:00' })")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import PageEditor from '@/components/clinic/PageEditor.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import EmailPreview from '@/components/clinic/marketing/EmailPreview.vue'

export default {
  components: { PageEditor, DatePickerField, EmailPreview },
  props: {
    blastData: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      showFroala: false,
      blast: {
        name:  'Offer message',
        send_cue: 'offer_activated',
        type: 'offer',
        method: 'email'
      },
      schedules: [{ time: '00:00' }],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.$nextTick(() => {
        this.showFroala = true
      })
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.schedules.length) {
          this.schedules = blast.schedules.map(schedue => {
            return {
              date: DateTime.fromISO(schedue.scheduled_for).toFormat('yyyy-MM-dd'),
              time: DateTime.fromISO(schedue.scheduled_for).toFormat('HH:mm')
            }
          })
        }
        this.blast = blast
      }
    },
    insertValue (value) {
      let text = ''
      let code = ''
      if (value === 'offer_code' && this.offer.redeem_method === 'general_code') {
        code = this.offer.coupon_code
      } else {
        code = `{{ ${value} }}`
      }
      if (this.blast.content) {
        text = `${this.blast.content} ${code}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    deleteSchedule () {
      this.schedules.pop()
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let payload = {
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        preview_text: this.blast.preview_text,
        subject: this.blast.subject,
        content: this.blast.content,
        send_cue: this.blast.send_cue,
        schedules: []
      }
      if (payload.send_cue === 'scheduled') {
        payload.schedules = this.schedules.map(m => {
          return `${m.date} ${m.time}`
        })
      }
      if (this.blast.id) {
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
          .then(() => {
            this.$emit('updated')
            this.closeDialog()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
          .then(() => {
            this.$emit('updated')
            this.closeDialog()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    getTodayDate () {
      return DateTime.local().toFormat('yyyy-MM-dd')
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>